// extracted by mini-css-extract-plugin
export default {"link":"eB-z","disabled":"fB-z"};